interface CHAT_CONFIG_KEYS {
  [key: string]: any;
}

export const CHAT_CONFIG = {
  user: {
    smilecare_bot: {
      textArea: false,
      headerText: "#smileCare",
      backIcon: true,
      footer: false,
      templateIcon: false,
      logoIcon: "T"
    },
    wa_app_support_bot: {
      textArea: true,
      headerText: "#toothsiCare",
      backIcon: true,
      footer: true,
      templateIcon: false,
      logoIcon: "T"
    },
    chatbottoothsi: {
      textArea: true,
      headerText: "#toothsiCare",
      backIcon: true,
      footer: true,
      templateIcon: false,
      logoIcon: "T"
    },
    skinnsi_chatbot: {
      textArea: true,
      headerText: "#skinnsiCare",
      backIcon: true,
      footer: true,
      templateIcon: false,
      logoIcon: "S"
    },
    agent: {
      textArea: true,
      headerText: "",
      backIcon: true,
      footer: true,
      templateIcon: false
    },
    makeo_buddy: {
      textArea: true,
      headerText: "",
      backIcon: true,
      footer: true,
      templateIcon: false,
      logoIcon: "M"
    }
  },
  agent: {
    textArea: true,
    headerText: "",
    backIcon: true,
    footer: true,
    templateIcon: true
  }
} as CHAT_CONFIG_KEYS;

export const viewFor = window.location.pathname.includes("/user/chat")
  ? "user"
  : window.location.pathname.includes("/transcript/chat")
  ? "transcript"
  : "agent";
